import { PricingCard } from 'components/base';
import useTranslation from 'hooks/useTranslation';

const Pricing = () => {
  const translation = useTranslation();

  const priceList = [
    {
      title: translation.basicPlan,
      content: translation.alreadyHaveWebsite,
      packages: translation.landingPage,
      price: '2000',
    },
    {
      title: translation.starterPlan,
      content: translation.dontHaveWebsite,
      packages: translation.landingPageHosting,
      price: '2900',
    },
    {
      title: translation.fullPlan,
      content: translation.startingNewBusiness,
      packages: translation.brandingLandingPageHosting,
      price: '3900',
    },
  ];

  return (
    <div className="flex flex-col bg-background-blue py-20 px-4 lg:items-center lg:px-[147px] lg:py-[160px]">
      <div className="flex flex-col lg:items-center">
        <p className="text-xs font-bold uppercase tracking-wide text-white">
          {translation.ourPlansPricing}
        </p>
        <p className="mt-3 text-2xl font-bold text-white lg:mt-4 lg:text-[34px] lg:leading-[46px]">
          {translation.selectPlan}
        </p>
      </div>

      <div className="mt-[44px] flex flex-col items-center lg:mt-[64px] lg:w-full lg:flex-row lg:justify-around">
        {priceList.map((item, idx) => (
          <PricingCard
            key={idx}
            title={item.title}
            content={item.content}
            packages={item.packages}
            price={item.price}
            className={idx % 2 === 0 ? 'bg-white' : 'bg-background-sky-blue'}
          />
        ))}
      </div>
    </div>
  );
};

export default Pricing;
